import React, { useState } from "react";
import ThemedChartCard from "../ThemedChartCard";

const TotalTripsChart = ({ tripsByStatus }) => {
  const statusValues = tripsByStatus || {};

  const tripData = [
    { name: "Active", value: statusValues.ACTIVE || 0, color: "bg-blue-500", description: "Currently active trips" },
    { name: "Pending", value: statusValues.PENDING || 0, color: "bg-purple-500", description: "Awaiting confirmation" },
    { name: "Completed", value: (statusValues.COMPLETED || 0) + (statusValues.AUTO_COMPLETE || 0), color: "bg-green-500", description: "Successfully finished trips" },
    { name: "Cancelled", value: statusValues.CANCELLED || 0, color: "bg-red-500", description: "Trips cancelled" },
    { name: "Delayed", value: statusValues.DELAYED || 0, color: "bg-yellow-500", description: "Delayed trips" },
  ];

  const total = tripData.reduce((sum, item) => sum + item.value, 0) || 1;
  const [hoveredItem, setHoveredItem] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  const handleMouseEnter = (item, event) => {
    setHoveredItem(item);
    const rect = event.currentTarget.getBoundingClientRect();
    setTooltipPosition({
      x: rect.left + window.scrollX,
      y: rect.top + window.scrollY - 50
    });
  };

  return (
    <ThemedChartCard title="Total Trips" className="h-[270px]">
      <div className="flex flex-col w-full h-full">
        <div className="flex justify-between items-center mb-3">
          <div className="text-sm font-medium text-muted-foreground">
            Trip Status Distribution
          </div>
          <div className="bg-background rounded-lg px-2 py-1 shadow-sm">
            <span className="text-base font-bold text-foreground">
              {total.toLocaleString()}
            </span>
            <span className="ml-1 text-muted-foreground text-xs">Total</span>
          </div>
        </div>

        <div className="flex-grow overflow-hidden relative">
          <div className="space-y-3 h-full flex flex-col justify-center">
            {tripData.map((item, index) => (
              <div 
                key={index} 
                className="flex items-center relative"
                onMouseEnter={(e) => handleMouseEnter(item, e)}
                onMouseLeave={() => setHoveredItem(null)}
              >
                <div className="w-20 text-xs text-muted-foreground truncate">
                  {item.name}
                </div>
                <div className="flex-grow mx-2">
                  <div className="flex items-center">
                    <div
                      className={`${item.color} h-5 rounded-sm transition-all duration-200 ease-in-out`}
                      style={{
                        width: `${(item.value / total) * 100}%`,
                        minWidth: "30px",
                        maxWidth: "100%",
                      }}
                    />
                    <span className="ml-2 text-sm font-medium text-foreground whitespace-nowrap">
                      {item.value.toLocaleString()}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {hoveredItem && (
        <div 
          className="fixed bg-background border border-border rounded-lg p-3 shadow-lg z-50 pointer-events-none"
          style={{
            left: tooltipPosition.x,
            top: tooltipPosition.y,
            transform: 'translateY(-100%)',
            minWidth: '200px'
          }}
        >
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <div className={`w-3 h-3 ${hoveredItem.color} rounded-sm mr-2`}></div>
              <span className="font-medium text-foreground">{hoveredItem.name}</span>
            </div>
            <span className="font-bold text-foreground">{hoveredItem.value.toLocaleString()}</span>
          </div>
          <div className="text-xs text-muted-foreground mt-1">
            {hoveredItem.description}
          </div>
        </div>
      )}
    </ThemedChartCard>
  );
};

export default TotalTripsChart;